<template>
  <div>
    <div
      class="modal fade"
      id="modal-form-cambio-trinomios"
      tabindex="-1"
      role="dialog"
      aria-hidden="true"
      data-backdrop="static"
      data-keyboard="false"
    >
      <div class="modal-dialog modal-lg">
        <div class="modal-content">
          <div class="modal-header bg-geogo-top-left pt-2 pb-2">
            <h4 class="modal-title text-white">Cambio {{ entidad }}</h4>
            <button
              type="button"
              class="close text-white"
              data-dismiss="modal"
              aria-label="Close"
              id="close-modal"
              ref="closeModalAut"
            >
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <!-- Formulario Vehículo -->
          <div class="modal-body" v-if="entidad && entidad == 'Vehiculo'">
            <div class="row">
              <div class="form-group col-md-6">
                <label for="vehículo">Vehículo Actual</label>
                <input
                  type="text"
                  class="form-control form-control-sm"
                  id="vehiculo"
                  readonly
                  v-model="form.vehiculoPlacaAnt"
                />
              </div>
              <div class="form-group col-md-6">
                <label for="vehículo">Vehículo Sustituye</label>
                <v-select
                  :class="[
                    $v.form.vehiculo_id.$invalid ? 'is-invalid' : 'is-valid',
                    $store.getters.getDarkMode ? 'dark-vselect' : '',
                  ]"
                  v-model="vehiculo"
                  placeholder="Placa"
                  label="placa"
                  class="form-control form-control-sm p-0"
                  :options="listasForms.vehiculos"
                  @search="buscarVehiculos"
                  @input="validarTipoVehiculo"
                ></v-select>
                <div class="error" v-if="!$v.form.vehiculo_id.required">
                  Ingrese una Placa
                </div>
              </div>
              <div class="form-group col-md-12">
                <label for="justificacion">Justificacion</label>
                <textarea
                  v-model="form.justificacion"
                  cols="30"
                  rows="5"
                  class="form-control form-control-sm"
                  :class="
                    $v.form.justificacion.$invalid ? 'is-invalid' : 'is-valid'
                  "
                ></textarea>
                <div class="error" v-if="!$v.form.justificacion.required">
                  Ingrese una Justificación
                </div>
              </div>
            </div>
          </div>
          <div
            class="modal-footer p-1"
            v-if="
              entidad &&
              entidad == 'Vehiculo' &&
              !$v.form.justificacion.$invalid &&
              !$v.form.vehiculo_id.$invalid
            "
          >
            <button
              type="button"
              class="btn btn-primary"
              @click="cambioVehiculo()"
            >
              Realizar Cambio
            </button>
          </div>
          <!-- Formulario Remolque -->
          <div class="modal-body" v-if="entidad && entidad == 'Remolque'">
            <div class="row">
              <div class="form-group col-md-6">
                <label for="remolque">Remolque Actual</label>
                <input
                  type="text"
                  class="form-control form-control-sm"
                  id="remolque"
                  readonly
                  v-model="form.remolquePlacaAnt"
                />
              </div>
              <div class="form-group col-md-6">
                <label for="remolque">Remolque Sustituye</label>
                <v-select
                  :class="[
                    $v.form.remolque_id.$invalid ? 'is-invalid' : 'is-valid',
                    $store.getters.getDarkMode ? 'dark-vselect' : '',
                  ]"
                  v-model="remolque"
                  placeholder="Placa"
                  label="placa"
                  class="form-control form-control-sm p-0"
                  :options="listasForms.remolques"
                  @search="buscarRemolques"
                  @input="seleccionarRemolque"
                ></v-select>
                <div class="error" v-if="!$v.form.remolque_id.required">
                  Ingrese una Placa
                </div>
              </div>
              <div class="form-group col-md-12">
                <label for="justificacion">Justificacion</label>
                <textarea
                  v-model="form.justificacion"
                  cols="30"
                  rows="5"
                  class="form-control form-control-sm"
                  :class="
                    $v.form.justificacion.$invalid ? 'is-invalid' : 'is-valid'
                  "
                ></textarea>
                <div class="error" v-if="!$v.form.justificacion.required">
                  Ingrese una Justificación
                </div>
              </div>
            </div>
          </div>
          <div
            class="modal-footer p-1"
            v-if="
              entidad &&
              entidad == 'Remolque' &&
              !$v.form.justificacion.$invalid &&
              !$v.form.remolque_id.$invalid
            "
          >
            <button
              type="button"
              class="btn btn-primary"
              @click="cambioRemolque()"
            >
              Realizar Cambio
            </button>
          </div>
          <!-- Formulario Conductor -->
          <div class="modal-body" v-if="entidad && entidad == 'Conductor'">
            <div class="row">
              <div class="form-group col-md-12">
                <label for="conductor">Conductor Actual</label>
                <input
                  type="text"
                  class="form-control form-control-sm"
                  id="conductor"
                  readonly
                  v-model="form.conductorAnt"
                />
              </div>
              <div class="form-group col-md-12">
                <label for="conductor">Conductor Sustituye</label>
                <v-select
                  :class="[
                    $v.form.conductor_id.$invalid ? 'is-invalid' : 'is-valid',
                    $store.getters.getDarkMode ? 'dark-vselect' : '',
                  ]"
                  v-model="conductor"
                  placeholder="Nombre Conductor"
                  label="nombre"
                  class="form-control form-control-sm p-0"
                  :options="listasForms.conductores"
                  @search="buscarConductores"
                  @input="seleccionarConductor"
                ></v-select>
                <div class="error" v-if="!$v.form.conductor_id.required">
                  Ingrese un Conductor
                </div>
              </div>
              <div class="form-group col-md-12">
                <label for="justificacion">Justificacion</label>
                <textarea
                  v-model="form.justificacion"
                  cols="30"
                  rows="5"
                  class="form-control form-control-sm"
                  :class="
                    $v.form.justificacion.$invalid ? 'is-invalid' : 'is-valid'
                  "
                ></textarea>
                <div class="error" v-if="!$v.form.justificacion.required">
                  Ingrese una Justificación
                </div>
              </div>
            </div>
          </div>
          <div
            class="modal-footer p-1"
            v-if="
              entidad &&
              entidad == 'Conductor' &&
              !$v.form.justificacion.$invalid &&
              !$v.form.conductor_id.$invalid
            "
          >
            <button
              type="button"
              class="btn btn-primary"
              @click="cambioConductor()"
            >
              Realizar Cambio
            </button>
          </div>
          <!-- Formulario Ruta -->
          <div class="modal-body" v-if="entidad && entidad == 'Ruta'">
            <div class="row">
              <div class="form-group col-md-6">
                <label for="ruta">Ruta actual</label>
                <input
                  type="text"
                  class="form-control form-control-sm"
                  id="ruta"
                  readonly
                  v-model="form.rutaAnt"
                />
              </div>
              <div class="form-group col-md-6">
                <label for="ruta">Ruta sustituye</label>
                <v-select
                  :class="[
                    $v.form.ruta_id.$invalid ? 'is-invalid' : 'is-valid',
                    $store.getters.getDarkMode ? 'dark-vselect' : '',
                  ]"
                  v-model="ruta"
                  placeholder="Ruta"
                  label="nombre"
                  class="form-control form-control-sm p-0"
                  :options="listasForms.rutas"
                  @search="buscarRutas"
                  @input="seleccionarRuta"
                ></v-select>
                <div class="error" v-if="!$v.form.ruta_id.required">
                  Ingrese una ruta
                </div>
              </div>
              <div class="form-group col-md-12">
                <label for="justificacion">Justificación</label>
                <textarea
                  v-model="form.justificacion"
                  cols="30"
                  rows="5"
                  class="form-control form-control-sm"
                  :class="
                    $v.form.justificacion.$invalid ? 'is-invalid' : 'is-valid'
                  "
                ></textarea>
                <div class="error" v-if="!$v.form.justificacion.required">
                  Ingrese una Justificación
                </div>
              </div>
            </div>
          </div>
          <div
            class="modal-footer p-1"
            v-if="
              entidad &&
              entidad == 'Ruta' &&
              !$v.form.justificacion.$invalid &&
              !$v.form.ruta_id.$invalid
            "
          >
            <button type="button" class="btn btn-primary" @click="cambioRuta()">
              Realizar Cambio
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import { required, minLength } from "vuelidate/lib/validators";
import vSelect from "vue-select";

export default {
  name: "GestionHidrocarburosCambios",

  components: {
    vSelect,
  },

  data() {
    return {
      data: null,
      entidad: null,
      vehiculo: {},
      remolque: {},
      conductor: {},
      ruta: {},
      form: {
        entidad_id: null,
        vehiculoPlacaAnt: null,
        vehiculo_id: null,
        conductor_id: null,
        conductorAnt: null,
        remolque_id: null,
        remolquePlacaAnt: null,
        ruta_id: null,
        rutaAnt: null,
        justificacion: null,
      },
      listasForms: {
        conductores: [],
        vehiculos: [],
        remolques: [],
        rutas: [],
      },
    };
  },

  validations: {
    form: {
      vehiculo_id: {
        required,
      },
      remolque_id: {
        required,
      },
      conductor_id: {
        required,
      },
      ruta_id: {
        required,
      },
      justificacion: {
        required,
        minLength: minLength(10),
      },
    },
  },

  methods: {
    getIndex(dataForm, entidad) {
      this.data = dataForm;
      this.entidad = entidad;
      this.cargarForm();
    },

    cargarForm() {
      this.resetForm();
      this.form.entidad_id = this.data.id;
      switch (this.entidad) {
        case "Vehiculo":
          this.form.vehiculoPlacaAnt = this.data.vehiculo_placa;
          break;
        case "Remolque":
          this.form.remolquePlacaAnt = this.data.remolque_placa;
          break;
        case "Conductor":
          this.form.conductorAnt = this.data.conductor_nombre;
          break;
        case "Ruta":
          this.form.rutaAnt = this.data.ruta_nombre;
          break;
      }
    },

    resetForm() {
      this.vehiculo = {};
      this.remolque = {};
      this.conductor = {};
      this.ruta = {};
      this.form = {
        vehiculo_id: null,
        vehiculoPlacaAnt: null,
        conductor_id: null,
        conductorAnt: null,
        remolque_id: null,
        remolquePlacaAnt: null,
        ruta_id: null,
        rutaAnt: null,
        justificacion: null,
      };
    },

    buscarVehiculos(search, loading) {
      if (search != "") {
        let me = this;
        loading(true);
        var url = "api/admin/vehiculos/lista?placa?placa=" + search;
        axios
          .get(url)
          .then(function (response) {
            me.listasForms.vehiculos = response.data;
            loading(false);
          })
          .catch(function (error) {
            this.$swal({
              icon: "error",
              title: "Ocurrio un error" + error,
              toast: true,
              position: "top-end",
              showConfirmButton: false,
              timer: 3000,
              timerProgressBar: true,
            });
          });
      }
    },

    buscarRemolques(search, loading) {
      if (search != "") {
        let me = this;
        loading(true);
        var url = "api/admin/remolques/lista?placa=" + search;
        axios
          .get(url)
          .then(function (response) {
            me.listasForms.remolques = response.data;
            loading(false);
          })
          .catch(function (error) {
            this.$swal({
              icon: "error",
              title: "Ocurrio un error" + error,
              toast: true,
              position: "top-end",
              showConfirmButton: false,
              timer: 3000,
              timerProgressBar: true,
            });
          });
      }
    },

    buscarConductores(search, loading) {
      if (search != "") {
        let me = this;
        loading(true);
        var url = "api/admin/conductores/lista?numero_documento=" + search;
        axios
          .get(url)
          .then(function (response) {
            me.listasForms.conductores = response.data;
            loading(false);
          })
          .catch(function (error) {
            this.$swal({
              icon: "error",
              title: "Ocurrio un error" + error,
              toast: true,
              position: "top-end",
              showConfirmButton: false,
              timer: 3000,
              timerProgressBar: true,
            });
          });
      }
    },

    buscarRutas(search, loading) {
      if (search != "") {
        let me = this;
        loading(true);
        var url = "/api/admin/rutas/lista?nombre=" + search;
        axios
          .get(url, {
            params: {
              origen_id: this.data.sitio_cargue_id,
            },
          })
          .then(function (response) {
            me.listasForms.rutas = response.data;
            loading(false);
          })
          .catch(function (error) {
            this.$swal({
              icon: "error",
              title: "Ocurrio un error" + error,
              toast: true,
              position: "top-end",
              showConfirmButton: false,
              timer: 3000,
              timerProgressBar: true,
            });
          });
      }
    },

    seleccionarRuta() {
      this.form.ruta_id = null;
      if (this.ruta) {
        this.form.ruta_id = this.ruta.id;
      }
    },

    seleccionarVehiculo() {
      this.form.vehiculo_id = null;
      if (this.vehiculo) {
        this.form.vehiculo_id = this.vehiculo.id;
      }
    },

    seleccionarRemolque() {
      this.form.remolque_id = null;
      if (this.remolque) {
        this.form.remolque_id = this.remolque.id;
      }
    },

    seleccionarConductor() {
      this.form.conductor_id = null;
      if (this.conductor) {
        this.form.conductor_id = this.conductor.id;
      }
    },

    validarTipoVehiculo() {
      if (
        this.vehiculo &&
        this.vehiculo.tipo_vehiculo_id != this.data.tipo_vehiculo_id
      ) {
        this.$swal({
          icon: "error",
          title:
            "El tipo de vehículo de la placa seleccionada no corresponde al solicitado para este servicio, por favor seleccione vehículo.",
          toast: true,
          position: "top-end",
          showConfirmButton: false,
          timer: 4000,
          timerProgressBar: true,
        });
        this.vehiculo = null;
        this.form.vehiculo_id = null;
      }
      this.seleccionarVehiculo();
    },

    cambioVehiculo() {
      this.$swal({
        title: "Esta seguro de cambiar este vehículo?",
        text: "No podra revertir esta acción",
        icon: "warning",
        showCancelButton: true,
        confirmButtonText: "Si, Realizar el cambio!",
      }).then((result) => {
        if (result.value) {
          axios
            .put("/api/admin/centralTrafico/cambiarVehiculo", {
              entidad_id: this.data.tipo_entidad_id,
              tipo_entidad_type: this.data.tipo_entidad_type,
              vehiculo_old_id: this.data.vehiculo_id,
              vehiculo_new_id: this.form.vehiculo_id,
              vehiculo_old_placa: this.data.vehiculo_placa,
              vehiculo_new_placa: this.vehiculo.placa,
              remolque_placa: this.data.remolque_placa,
              justificacion: this.form.justificacion,
              estado_entidad: this.data.estado_entidad,
            })
            .then((response) => {
              this.$refs.closeModalAut.click();
              this.$parent.cargarDatos();
              this.$swal({
                icon: "success",
                title: response.data.mensaje,
                toast: true,
                position: "top-end",
                showConfirmButton: false,
                timer: 3000,
                timerProgressBar: true,
              });
            });
        }
      });
    },

    cambioRuta() {
      this.$swal({
        title: "Esta seguro de cambiar este ruta?",
        text: "No podra revertir esta acción",
        icon: "warning",
        showCancelButton: true,
        confirmButtonText: "Si, Realizar el cambio!",
      }).then((result) => {
        if (result.value) {
          axios
            .put("/api/admin/centralTrafico/cambiarRuta", {
              entidad_id: this.data.tipo_entidad_id,
              tipo_entidad_type: this.data.tipo_entidad_type,
              ruta_old_id: this.data.ruta_id,
              ruta_new_id: this.form.ruta_id,
              ruta_old: this.data.ruta_nombre,
              ruta_new: this.ruta.nombre,
              justificacion: this.form.justificacion,
              vehiculo: this.data.vehiculo_placa,
              remolque: this.data.remolque_placa,
              estado_entidad: this.data.estado_entidad,
            })
            .then((response) => {
              this.$refs.closeModalAut.click();
              this.$parent.cargarDatos();
              this.$swal({
                icon: "success",
                title: response.data.mensaje,
                toast: true,
                position: "top-end",
                showConfirmButton: false,
                timer: 3000,
                timerProgressBar: true,
              });
            });
        }
      });
    },

    cambioRemolque() {
      this.$swal({
        title: "Esta seguro de cambiar este remolque?",
        text: "No podra revertir esta acción",
        icon: "warning",
        showCancelButton: true,
        confirmButtonText: "Si, Realizar el cambio!",
      }).then((result) => {
        if (result.value) {
          axios
            .put("/api/admin/centralTrafico/cambiarRemolque", {
              entidad_id: this.data.tipo_entidad_id,
              tipo_entidad_type: this.data.tipo_entidad_type,
              remolque_old_id: this.data.remolque_id,
              remolque_new_id: this.form.remolque_id,
              remolque_old_placa: this.data.remolque_placa,
              remolque_new_placa: this.remolque.placa,
              justificacion: this.form.justificacion,
              estado_entidad: this.data.estado_entidad,
            })
            .then((response) => {
              this.$refs.closeModalAut.click();
              this.$parent.cargarDatos();
              this.$swal({
                icon: "success",
                title: response.data.mensaje,
                toast: true,
                position: "top-end",
                showConfirmButton: false,
                timer: 3000,
                timerProgressBar: true,
              });
            });
        }
      });
    },

    cambioConductor() {
      this.$swal({
        title: "Esta seguro de cambiar este conductor?",
        text: "No podra revertir esta acción",
        icon: "warning",
        showCancelButton: true,
        confirmButtonText: "Si, Realizar el cambio!",
      }).then((result) => {
        if (result.value) {
          axios
            .put("/api/admin/centralTrafico/cambiarConductor", {
              entidad_id: this.data.tipo_entidad_id,
              tipo_entidad_type: this.data.tipo_entidad_type,
              conductor_new_id: this.form.conductor_id,
              conductor_old_id: this.data.conductor_id,
              conductor_new: this.conductor.nombre,
              conductor_old: this.data.conductor_nombre,
              justificacion: this.form.justificacion,
              estado_entidad: this.data.estado_entidad,
            })
            .then((response) => {
              this.$refs.closeModalAut.click();
              this.$parent.cargarDatos();
              this.$swal({
                icon: "success",
                title: response.data.mensaje,
                toast: true,
                position: "top-end",
                showConfirmButton: false,
                timer: 3000,
                timerProgressBar: true,
              });
            });
        }
      });
    },
  },

  beforeMount() {},
};
</script>
